import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, Nav, NavItem, NavLink, CardBody, Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, CardFooter } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import { YearPickerInput, DatesProvider } from '@mantine/dates';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { useDispatch } from 'react-redux';
import { getRealEstateRegistryList } from '../../../slices/thunks';


const RegistrationOfWaterOwnership = ({validation}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getRealEstateRegistryList());
    }, [dispatch]);

    return (
        <React.Fragment>
            <div>
                <h5>Registro de Propiedad de Aguas C.B.R</h5>
                <p className="text-muted"></p>
                </div>
                
                <div>
                    <Row className='gx-2 align-items-center'>
                        <Col className='mb-3'>
                            <OSelect
                                key={validation.values.real_estate_registry_id || 'real_estate_registry_id'}
                                label="C.B.R"
                                id="real_estate_registry_id"
                                name="real_estate_registry_id"
                                value={validation.values.real_estate_registry_id || ''}
                                requestApi={() => dispatch(getRealEstateRegistryList()).then(res => res.payload)}
                                validation={validation}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <Label for='fojas' className='form-label'>
                                Fojas
                            </Label>
                            <Input
                                name='fojas'
                                id='fojas'
                                className='form-control'
                                placeholder='Ingrese Fojas'
                                type='text'
                                value={validation.values.fojas || ''}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <Label for='cbr_number' className='form-label'>
                                N° C.B.R    
                            </Label>
                            <Input
                                name='cbr_number'
                                id='cbr_number'
                                className='form-control'
                                placeholder='Ingrese N° C.B.R'
                                type='text'
                                value={validation.values.cbr_number || ''}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
                                <YearPickerInput
                                    label='Año'
                                    id='cbr_year'
                                    name='cbr_year'
                                    placeholder="Seleccione un año"
                                    value={validation.values.cbr_year && !isNaN(Number(validation.values.cbr_year)) ? new Date(Number(validation.values.cbr_year), 0, 1) : null}
                                    onChange={(date) => {
                                        // Extract only the year as number
                                        const year = date ? date.getFullYear() : null;
                                        validation.setFieldValue("cbr_year", year);
                                    }}
                                    onBlur={validation.handleBlur}
                                    maxDate={new Date()}
                                    error={
                                        validation.touched['cbr_year'] &&
                                            validation.errors['cbr_year']
                                            ? validation.errors['cbr_year'] : ''
                                    }
                                    clearable={true}
                                />
                            </DatesProvider>
                        </Col>
                    </Row>
                </div>
        </React.Fragment>
    )
}

export default RegistrationOfWaterOwnership;